// import { BrowserRouter as Router } from "react-router-dom";
// import { useLayoutEffect } from "react";
// import "./App.css";
// import AppRoutes from "./routes/AppRoutes";
// import { Provider } from "react-redux";
// import store from "./store"; // removed persistor
// import { SidebarProvider } from "./context/sidebarContext";
// import SessionTimeoutManager from "./pages/sessionTimeoutManager";
// import faviconIcon from "./assets/images/nhdcl-logo.jpg";

// function App() {
//   useLayoutEffect(() => {
//     document.title = "NHDCL FMS";

//     const favicon =
//       document.querySelector("link[rel*='icon']") ||
//       document.createElement("link");
//     favicon.type = "image/jpeg";
//     favicon.rel = "shortcut icon";
//     favicon.href = faviconIcon;

//     const existingFavicon = document.querySelector("link[rel='icon']");
//     if (existingFavicon) {
//       existingFavicon.remove();
//     }

//     document.getElementsByTagName("head")[0].appendChild(favicon);
//   }, []);

//   return (
//     <Provider store={store}>
//       <SidebarProvider>
//         <Router>
//           <AppRoutes />
//           <SessionTimeoutManager />
//         </Router>
//       </SidebarProvider>
//     </Provider>
//   );
// }

// export default App;

import { BrowserRouter as Router } from "react-router-dom";
import { useLayoutEffect, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./App.css";
// import "./pages/technicianpages/css/mobile-responsive.css";
import AppRoutes from "./routes/AppRoutes";
import { Provider } from "react-redux";
import store from "./store";
import SessionTimeoutManager from "./pages/sessionTimeoutManager";
import faviconIcon from "./assets/images/nhdcl_brow_logo.png";
import { logout } from "./slices/authSlice"; // import logout action
import { Toaster } from "sonner";

function AppContent() {
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("🚀 AppContent starting...");
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("userToken") ||
      sessionStorage.getItem("userToken");

    if (token) {
      console.log("🔑 Token found, checking expiration...");
      // Helper function to check if JWT is expired
      const isTokenExpired = (jwt) => {
        try {
          const parts = jwt.split(".");
          if (parts.length !== 3) {
            console.warn("⚠️ Invalid token format");
            return true;
          }
          const payload = JSON.parse(atob(parts[1]));
          const isExpired = payload.exp * 1000 < Date.now();
          if (isExpired) {
            console.warn("⏰ Token expired");
          }
          return isExpired;
        } catch (e) {
          console.error("❌ Token decode failed:", e);
          return true;
        }
      };

      if (isTokenExpired(token)) {
        console.log("🧹 Clearing expired session");
        dispatch(logout());
        sessionStorage.clear();
        localStorage.clear();
      } else {
        console.log("✅ Token is valid");
      }
    } else {
      console.log("ℹ️ No token found");
    }
  }, [dispatch]);

  useLayoutEffect(() => {
    document.title = "NHDCL FMS";

    const favicon =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    favicon.type = "image/png";
    favicon.rel = "icon shortcut";
    favicon.href = faviconIcon;

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.remove();
    }

    document.getElementsByTagName("head")[0].appendChild(favicon);
  }, []);

  return (
    <>
      <AppRoutes />
      <SessionTimeoutManager />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
